// features/template.placeholders.js
//
// Shared {{placeholder}} extraction logic — used by TestTemplateDialog.jsx
// (testing an already-saved template) and the template-wizard's test step
// (testing an in-progress draft), so both stay in sync with a single regex.

const PLACEHOLDER_REGEX = /\{\{(\w+)\}\}/g;

export const extractPlaceholders = (template) => {
  const keys = new Set();
  const scan = (str) => {
    if (!str) return;
    PLACEHOLDER_REGEX.lastIndex = 0;
    let match;
    while ((match = PLACEHOLDER_REGEX.exec(str)) !== null) keys.add(match[1]);
  };
  scan(template?.subject);
  scan(template?.eyebrow);
  scan(template?.heading);
  scan(template?.body_html);
  return Array.from(keys);
};

export const placeholderLabel = (key) =>
  key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

export const COMMON_PLACEHOLDER_KEYS = [
  "first_name",
  "last_name",
  "project_name",
  "company_name",
  "otp",
  "action_url",
];

// Merge-tag keys the campaign sender can personalize per recipient.
// MUST stay in sync with the backend buildRecipientVars()
// (services/mailer/merge_tags.js) — only MARKETING templates are sent via
// campaigns, so this list is offered only for that mailing_for.
export const CAMPAIGN_MERGE_KEYS = [
  "first_name",
  "last_name",
  "full_name",
  "name",
  "email",
  "phone",
  "city",
  "location",
  "company_name",
];
